// extracted by mini-css-extract-plugin
module.exports = {"CountDown":"CountDownTimer_CountDown__1mQpz","outer":"CountDownTimer_outer__bo_io","inner":"CountDownTimer_inner__21cln"};